module.exports = __webpack_public_path__ + "static/media/badge_level_4_1.f94582ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_4_1.png
// module id = 490
// module chunks = 0